import React from 'react';

const ChannelContext = React.createContext({
  channel: null,
  channels: null
});

export default ChannelContext;
